import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for push notifications.
// PROD-only gate: the built sw.js has its bare Workbox imports (e.g.
// `import { precacheAndRoute } from 'workbox-precaching'`) bundled in by
// vite-plugin-pwa's injectManifest at build time. In dev, Vite serves
// public/sw.js raw (unbundled), so those imports would throw a SyntaxError
// as soon as the browser registers it — silently killing the SW and push.
// To exercise the real service worker locally, run `npm run build` and
// serve/preview the `build/` output instead of `npm start`.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(registration => {
        console.log('Service Worker registered:', registration.scope);
      })
      .catch(error => {
        console.log('Service Worker registration failed:', error);
      });
  });
}
